import { useState, useContext } from 'react';
import { AppContext } from '../../../sporttia/all';
import DeviceAuthDialog from '../../../components/devices/DeviceAuthDialog';
import DeviceList from '../../../components/devices/DeviceList';
import deviceConstants from '../../../components/devices/deviceConstants';
import { Device } from '../../../types/models/DeviceSpace';
import { PERMISSIONS } from '../../../lib/permissions';

type DeviceAuth = {
    id?: number;
    dateini: string;
    dateend: string;
    timeini: string;
    timeend: string;
    weekdays: number[];
    devices?: Device[];
    [key: string]: unknown;
};

type Item = {
    id: string | number;
    ini?: string;
    end?: string;
    dateini?: string;
    dateend?: string;
};

type Props = {
    item: Item;
};

/**
 * GroupDevices : Group screen devices tab section. Contains the list of authorized devices for this group
 * params:
 *  Object item - the group
 */
export default function GroupDevices({ item }: Props): React.ReactElement {
    const [auths, setAuths] = useState<DeviceAuth[]>([]); // auth rows
    const [viewAuth, setViewAuth] = useState<DeviceAuth | null>(null); // auth to open in the DeviceAuthDialog

    const cxt = useContext(AppContext)!;

    // Load from API
    function loadAuths() {
        cxt?.api('GET', `/groups/${item.id}/devices/auths`, {
            params: { rows: 25, page: 1 },
            success: (result: { rows?: DeviceAuth[] }) => {
                if (result.rows) {
                    setAuths(result.rows);
                }
            },
        });
    }

    return (
        <div>
            <DeviceList
                item={item as any}
                type={deviceConstants.GROUP}
                auths={auths as any}
                loaderFunction={loadAuths}
                onCreate={(device: any) => setViewAuth(device as DeviceAuth)}
                onSelect={(device: any) => setViewAuth(device as DeviceAuth)}
            />
            {viewAuth && (
                <DeviceAuthDialog
                    open
                    permission={PERMISSIONS.GROUP.MODIFY}
                    item={{
                        ...viewAuth,
                        dateini: viewAuth.dateini || '',
                        dateend: viewAuth.dateend || '',
                        timeini: viewAuth.timeini || '',
                        timeend: viewAuth.timeend || '',
                        weekdays: viewAuth.weekdays || [],
                        devices: viewAuth.devices || [],
                    }}
                    onSave={loadAuths}
                    onClose={() => setViewAuth(null)}
                />
            )}
        </div>
    );
}
